// extracted by mini-css-extract-plugin
module.exports = {"Component":"StepAmenitiesService_Component__wnqBH","FormAction":"StepAmenitiesService_FormAction__2QC9o"};